import React, {Component} from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core'
import styles from './styles'
import {contentData} from './content'
import BasicView from '../../../../components/Layouts/BasicView/BasicView'
import ProfileInfo from './ProfileInfo/ProfileInfo'
import {request_user} from './requests'

class UserProfile extends Component{

  state = {
    isloading:false,
    user:null
  }

  componentDidMount(){
    this.initModule()
  }

  initModule = async() => {
    this.setState({isloading:true})
    let response = await request_user()
    this.setState({user:{...response}})
    this.setState({isloading:false})
  }

  onEditUser = async() => {
    const {history} = this.props
    history.push('/profile/edit')
  }

  onReturn = () => {
    const {history} = this.props
    history.push('/agents')
  }


  render(){

    const { history, language, catalogs, translations} = this.props
    const {user} = this.state
    const content = contentData[language]
    
    return(
      <BasicView
        history={history}
        selected={0}
        onChange={this.onChangeView}
        content={content.layout}
      >
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <ProfileInfo
              language={language}
              catalogs={catalogs}
              user={user}
              translations={translations}
              onEdit={this.onEditUser}
            />
          </Grid>
        </Grid>
        
      </BasicView>
      
    )
  }
}

export default withStyles(styles)(UserProfile)